import Vue from 'vue';

// 开启调试工具
Vue.config.productionTip = true;
if (process.env.NODE_ENV !== 'production') {
  Vue.config.devtools = true;
}

// 控制台日志打印处理
import '@/app-shared/extension/vh-console';
// 重置 elementUI 的 message
import '@/app-shared/extension/message';
// 全局属性的定义
import './init-global/prototype';
// 导入根组件
import App from './App.vue';
// 组件库环境全局配置
// import './init-global/hcl-config';
// 导入路由
import router from './router';
// 引入国际化组件
import i18n, { loadLocaleMessages } from '@/app-shared/i18n/index';
// domain store
import domainStore from './init-global/store';
// 组件use
import './init-global/use';
// 全局属性及方法
import '@/app-shared/extension/global';
// 全局混入
import '@/app-shared/mixins/index';
// 全局指令
import '@/app-shared/directives/index';
// 全局过滤器
import '@/app-shared/filters/index';
// 导入样式及皮肤
import './assets/styles/common.less';
//通讯组件
import { emitter, EMIT_DEFINE } from '@/app-shared/utils/emitter';

import '@/app-shared/assets/css/uno.less';
import '@/app-shared/assets/css/standard.less';
// 默认主题
import skins from '@/app-shared/skins/watch';
skins.applyTheme('theme_default_black');

const localUserLang = localStorage.getItem('user-lang');
loadLocaleMessages(['zh', 'en'].includes(localUserLang) ? localUserLang : 'zh');

//三方组件库
Vue.use(VueLazyload, {
  observer: true
});

dayjs.extend(window.dayjs_plugin_duration);

// 全局版本变量
window.app_global_variable = {
  VUE_APP_BUILD_VERSION: process.env.VUE_APP_BUILD_VERSION
};
//全局挂载事件通讯

Vue.prototype.$emitter = emitter;
Vue.prototype.$EMIT_DEFINE = EMIT_DEFINE;

new Vue({
  router,
  i18n,
  domainStore,
  render: h => h(App)
}).$mount('#app');
